import { get, compact, isUndefined, isNull, isEmpty } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants.js'

import {
  PATHS as CUSTOMER_PATHS,
  CONSTANTS as CUSTOMER_BILLING_CONSTANTS,
} from '@/js/helper/aimeos-customer-constants.js'
import {
  PATHS as CUSTOMER_ADDRESS_PATHS,
  CONSTANTS as CUSTOMER_ADDRESS_CONSTANTS,
} from '@/js/helper/aimeos-customer-address-constants.js'

import CUSTOMER_GETTER_TYPE from '../getter-types/customer-getter-types'
import CHECKOUT_GETTER_TYPE from '../getter-types/checkout-getter-types'
import CUSTOMER_GENERATE_GETTER_TYPES from '../getter-types/customer-generate-getter-types'
// import CUSTOMER_GENERATE_ADDRESS_GETTER_TYPE from '../getter-types/customer-generate-address-getter-types'

import { getRelatedIncludes } from '@/js/helper/relationships-helper.js'
import {
  hasAddressRequiredAttributes,
  missingAddressRequiredAttributes,
  formatDeliveryAddress,
} from '@/js/helper/aimeos-basket-address-helper.js'

export const getCustomerGetters = REQUEST_TYPES => ({
  ...Object.keys({ ...CUSTOMER_GENERATE_GETTER_TYPES }).reduce(
    (getterTypes, type) => ({
      ...getterTypes,
      [`CUSTOMER_${type}`]: state =>
        get(state, [REQUEST_TYPES.CUSTOMER.dataKey, API_CONSTANTS.DATA, ...CUSTOMER_PATHS[type]]),
    }),
    {},
  ),
  [CUSTOMER_GETTER_TYPE.CUSTOMER_ADDRESSES]: (state, getters) => {
    return [
      {
        type: 'payment',
        address_id: getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.CODE}`],
        content: {
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.COMPANY]:
            getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.COMPANY}`],
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.ADDRESS1]:
            getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.ADDRESS1}`],
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.POSTAL]:
            getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.POSTAL}`],
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.CITY]:
            getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.CITY}`],
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.TELEPHONE]:
            getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.TELEPHONE}`],
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.TELEFAX]:
            getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.TELEFAX}`],
          email: getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.EMAIL}`],
          website: getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.WEBSITE}`],
        },
      },
      ...getters[CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES].map(adr => ({
        address_id: get(adr, CUSTOMER_ADDRESS_PATHS.SAP_ADDRESS_ID),
        type: 'delivery',
        content: {
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.COMPANY]: get(adr, CUSTOMER_ADDRESS_PATHS.COMPANY),
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.ADDRESS1]: get(
            adr,
            CUSTOMER_ADDRESS_PATHS.ADDRESS1,
          ),
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.POSTAL]: get(adr, CUSTOMER_ADDRESS_PATHS.POSTAL),
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.CITY]: get(adr, CUSTOMER_ADDRESS_PATHS.CITY),
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.SAP_ADDRESS_ID]: get(
            adr,
            CUSTOMER_ADDRESS_PATHS.SAP_ADDRESS_ID,
          ),
          [CUSTOMER_ADDRESS_CONSTANTS.ATTRIBUTE.BAAN_ADDRESS_ID]: get(
            adr,
            CUSTOMER_ADDRESS_PATHS.BAAN_ADDRESS_ID,
          ),
        },
      })),
    ]
  },
  [CUSTOMER_GETTER_TYPE.CUSTOMER_BILLING_ADDRESS]: (state, getters) => {
    return compact([
      getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.COMPANY}`],
      getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.ADDRESS1}`],
      getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.ADDRESS2}`],
      getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.ADDRESS3}`],
      compact([
        getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.POSTAL}`],
        getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.CITY}`],
      ]).join(' '),
      getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.COUNTRYID}`],
      getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES.EMAIL}`],
    ])
  },
  [CUSTOMER_GETTER_TYPE.CUSTOMER_RELATIONSHIPS]: state =>
    get(
      state,
      [REQUEST_TYPES.CUSTOMER.dataKey, API_CONSTANTS.DATA, API_CONSTANTS.RELATIONSHIPS],
      {},
    ),
  [CUSTOMER_GETTER_TYPE.CUSTOMER_INCLUDED]: state =>
    get(state, [REQUEST_TYPES.CUSTOMER.dataKey, API_CONSTANTS.INCLUDED], []),
  [CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES]: (state, getters) =>
    getRelatedIncludes({
      relationships: getters[CUSTOMER_GETTER_TYPE.CUSTOMER_RELATIONSHIPS],
      included: getters[CUSTOMER_GETTER_TYPE.CUSTOMER_INCLUDED],
      type: API_CONSTANTS.AIMEOS.TYPE.CUSTOMER_ADDRESS,
    }),
  [CUSTOMER_GETTER_TYPE.CUSTOMER_DEFAULT_DELIVERY_ADDRESS]: (state, getters) =>
    getters[CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES].find(
      address => get(address, API_CONSTANTS.ADDRESSES.SAP_ADDRESS_ID) === getters[`CUSTOMER_DEFAULT_ADDRESS_ID`],
    ),
  [CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES_FORMATTED]: (state, getters) =>
    getters[CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES].map(formatDeliveryAddress),
  [CUSTOMER_GETTER_TYPE.CUSTOMER_SELECTED_DELIVERY_ADDRESS_FORMATTED]: (state, getters) =>
    getters[CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES_FORMATTED].find(
      address => get(address, API_CONSTANTS.ID) === getters[CHECKOUT_GETTER_TYPE.DELIVERY_ADDRESS],
    ),

  [CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES_SAP]: (state, getters) =>
    getters[CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES].map(adr => ({
      ...adr,
      id: adr.attributes.sap_address_id,
    })),

  [CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES_FORMATTED_SAP]: (state, getters) =>
    getters[CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES_SAP].reduce((acc, address) => {
      acc[get(address, CUSTOMER_ADDRESS_PATHS.SAP_ADDRESS_ID)] = {
        ...formatDeliveryAddress(address),
        attributes: address.attributes,
      }
      return acc
    }, {}),

  [CUSTOMER_GETTER_TYPE.CUSTOMER_PAYMENT_ADDRESS_BASKET_PARTS]: (state, getters) => {
    const billingAddress = {
      [API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ID]: API_CONSTANTS.AIMEOS.BASKET.CONSTANTS.ID.PAYMENT,
      [API_CONSTANTS.ATTRIBUTES]: {
        ...Object.keys(API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ATTRIBUTE).reduce((validKeys, type) => {
          if (
            type !== 'WEBSITE' &&
            !isUndefined(getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES[type]}`]) &&
            !isNull(getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES[type]}`]) &&
            getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES[type]}`] !== ''
          ) {
            validKeys[API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ATTRIBUTE[type]] =
              type === 'ID'
                ? 'billing'
                : getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES[type]}`]
          }
          return validKeys
        }, {}),
      },
    }

    return billingAddress
  },
  [CUSTOMER_GETTER_TYPE.CUSTOMER_PAYMENT_ADDRESS_MISSING_DATA]: (state, getters) => {
    return missingAddressRequiredAttributes(
      getters[CUSTOMER_GETTER_TYPE.CUSTOMER_PAYMENT_ADDRESS_BASKET_PARTS],
    )
  },
  [CUSTOMER_GETTER_TYPE.CUSTOMER_PAYMENT_ADDRESS_BASKET]: (state, getters) => {
    if (
      !hasAddressRequiredAttributes(
        getters[CUSTOMER_GETTER_TYPE.CUSTOMER_PAYMENT_ADDRESS_BASKET_PARTS],
      )
    ) {
      return undefined
    }
    return getters[CUSTOMER_GETTER_TYPE.CUSTOMER_PAYMENT_ADDRESS_BASKET_PARTS]
  },
  [CUSTOMER_GETTER_TYPE.CUSTOMER_PAYMENT_ADDRESS]: (state, getters) => {
    const billingAddress = {
      // [API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ID]: API_CONSTANTS.AIMEOS.BASKET.CONSTANTS.ID.PAYMENT,
      [API_CONSTANTS.ATTRIBUTES]: {
        ...Object.keys(CUSTOMER_BILLING_CONSTANTS.ATTRIBUTE).reduce((validKeys, type) => {
          if (
            !isUndefined(getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES[type]}`]) &&
            !isNull(getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES[type]}`]) &&
            getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES[type]}`] !== ''
          ) {
            validKeys[CUSTOMER_BILLING_CONSTANTS.ATTRIBUTE[type]] =
              getters[`CUSTOMER_${CUSTOMER_GENERATE_GETTER_TYPES[type]}`]
          }
          return validKeys
        }, {}),
      },
    }
    return billingAddress
  },
  [CUSTOMER_GETTER_TYPE.CUSTOMER_PARENT_PAYMENT_ADDRESS]: (state, getters) => {
    return isEmpty(getters['CUSTOMER_PARENT_BILLING_ADDRESS'])
      ? {}
      : {
          // [API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ID]: API_CONSTANTS.AIMEOS.BASKET.CONSTANTS.ID.PAYMENT,
          [API_CONSTANTS.ATTRIBUTES]: {
            ...Object.keys(CUSTOMER_BILLING_CONSTANTS.ATTRIBUTE).reduce((validKeys, type) => {
              const key = CUSTOMER_BILLING_CONSTANTS.ATTRIBUTE?.[type]
              const value = key ? getters['CUSTOMER_PARENT_BILLING_ADDRESS']?.[key] : undefined
              if (!isUndefined(value) && !isNull(value) && value !== '') {
                validKeys[key] =
                  getters['CUSTOMER_PARENT_BILLING_ADDRESS'][
                    CUSTOMER_BILLING_CONSTANTS.ATTRIBUTE[type]
                  ]
              }
              return validKeys
            }, {}),
          },
        }
  },
  [CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES_BASKET]: (state, getters) =>
    getters[CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES].map(address => ({
      [API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ID]: API_CONSTANTS.AIMEOS.BASKET.CONSTANTS.ID.DELIVERY,
      [API_CONSTANTS.ATTRIBUTES]: {
        ...Object.keys(API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ATTRIBUTE).reduce((validKeys, type) => {
          if (
            type !== 'WEBSITE' &&
            !isUndefined(get(address, CUSTOMER_ADDRESS_PATHS[type])) &&
            !isNull(get(address, CUSTOMER_ADDRESS_PATHS[type])) &&
            get(address, CUSTOMER_ADDRESS_PATHS[type]) !== ''
          ) {
            validKeys[API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ATTRIBUTE[type]] = get(
              address,
              CUSTOMER_ADDRESS_PATHS[type],
            )
          }
          return validKeys
        }, {}),
      },
    })),
  [CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESS_BASKET]: (state, getters) => {
    if (isUndefined(getters[CHECKOUT_GETTER_TYPE.DELIVERY_ADDRESS])) {
      return undefined
    }
    const address = getters[CUSTOMER_GETTER_TYPE.CUSTOMER_DELIVERY_ADDRESSES].find(
      address => get(address, API_CONSTANTS.ID) === getters[CHECKOUT_GETTER_TYPE.DELIVERY_ADDRESS],
    )

    if (isUndefined(address)) {
      return undefined
    }

    const deliveryAddress = {
      [API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ID]: API_CONSTANTS.AIMEOS.BASKET.CONSTANTS.ID.DELIVERY,
      [API_CONSTANTS.ATTRIBUTES]: {
        ...Object.keys(API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ATTRIBUTE).reduce((validKeys, type) => {
          if (
            type !== 'WEBSITE' &&
            !isUndefined(get(address, CUSTOMER_ADDRESS_PATHS[type])) &&
            !isNull(get(address, CUSTOMER_ADDRESS_PATHS[type])) &&
            get(address, CUSTOMER_ADDRESS_PATHS[type]) !== ''
          ) {
            validKeys[API_CONSTANTS.AIMEOS.BASKET_ADDRESS.ATTRIBUTE[type]] = get(
              address,
              CUSTOMER_ADDRESS_PATHS[type],
            )
          }
          return validKeys
        }, {}),
      },
    }

    // if (!hasAddressRequiredAttributes(deliveryAddress)) {
    //   return undefined
    // }
    return deliveryAddress
  },
})
